export interface ArchitectureStandardFencePayload {
  uuid?: string | null;
  artifactType?: string;
  lifecyclePhase?: string;
  action?: string;
  name?: string;
  status?: string;
}

const BLOCK_RE = /```architecture-standard\s*([\s\S]*?)```/i;

export function parseArchitectureStandardFence(
  raw: string | null | undefined,
): ArchitectureStandardFencePayload | null {
  if (!raw?.trim()) return null;
  try {
    const parsed = JSON.parse(raw) as ArchitectureStandardFencePayload;
    if (!parsed || typeof parsed !== "object") return null;
    return parsed;
  } catch {
    return null;
  }
}

export function extractArchitectureStandardFromMessage(
  content: string,
): ArchitectureStandardFencePayload | null {
  const match = content.match(BLOCK_RE);
  if (!match?.[1]) return null;
  return parseArchitectureStandardFence(match[1].trim());
}
